define('reducer-training',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var initial = {
        components: {},
        imagePosition: 0,
        imageScaleMode: 0,
        isDebugMode: false,
        svgsInIndexHtml: false
    };

    exports.default = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
        var action = arguments[1];


        switch (action.type) {
            case 'SET_TRAINING':
                {
                    var _action$training = action.training,
                        training = _action$training === undefined ? {} : _action$training;


                    return Object.assign({}, state, {
                        components: action.components || initial.components,
                        imagePosition: training.imagePosition || initial.imagePosition,
                        imageScaleMode: training.imageScaleMode || initial.imageScaleMode,
                        isDebugMode: action.isDebugMode || initial.isDebugMode,
                        svgsInIndexHtml: training.svgsInIndexHtml || initial.svgsInIndexHtml
                    });
                }
            default:
                return state;
        }
    };
});
